export enum EntitledEntityTypeEnum {
  User = 'USER',
  Group = 'GROUP',
  Role = 'ROLE',
}
